<!-- One live region on the container: a role="status" per toast nested inside
     it made screen readers announce each message twice. Auto-dismiss pauses
     while the pointer or keyboard focus is inside (WCAG 2.2.1). -->
<div
  class="toaster"
  aria-live="polite"
  aria-atomic="false"
  (mouseenter)="onInteractionStart()"
  (mouseleave)="onInteractionEnd()"
  (focusin)="onInteractionStart()"
  (focusout)="onInteractionEnd()"
>
  @for (toast of toasts(); track toast.id) {
    <div class="toast toast--{{ toast.kind }}" data-testid="toast">
      @if (toast.onClick) {
        <button
          type="button"
          class="toast__body toast__body--action"
          data-testid="toast-body"
          (click)="onBodyClick(toast)"
        >
          <span class="toast__title">{{ toast.title }}</span>
          @if (toast.body) {
            <span class="toast__sub">{{ toast.body }}</span>
          }
        </button>
      } @else {
        <div class="toast__body" data-testid="toast-body">
          <div class="toast__title">{{ toast.title }}</div>
          @if (toast.body) {
            <div class="toast__sub">{{ toast.body }}</div>
          }
        </div>
      }
      <button
        type="button"
        class="toast__close"
        data-testid="toast-dismiss"
        aria-label="Dismiss notification"
        (click)="onDismiss(toast, $event)"
      >
        ×
      </button>
    </div>
  }
</div>
